exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pay_query--wrapper[data-v-a9727952]{padding:5rem 0}.pay_query--wrapper .pay_query[data-v-a9727952]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.pay_query--wrapper .pay_query .loading[data-v-a9727952]{width:10rem;height:auto}.pay_query--wrapper .pay_query .loading_txt[data-v-a9727952]{font-size:.875rem;color:#575757;line-height:1.25rem}", ""]);

// exports
